import { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ll_cart") || "[]");
    } catch { return []; }
  });

  const save = (next) => {
    setItems(next);
    localStorage.setItem("ll_cart", JSON.stringify(next));
  };

  const addItem = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.product.id === product.id);
      let next;
      if (exists) {
        next = prev.map((i) =>
          i.product.id === product.id
            ? { ...i, quantity: i.quantity + qty }
            : i
        );
      } else {
        next = [...prev, { product, quantity: qty }];
      }
      localStorage.setItem("ll_cart", JSON.stringify(next));
      return next;
    });
  }, []);

  const removeItem = useCallback((productId) => {
    setItems((prev) => {
      const next = prev.filter((i) => i.product.id !== productId);
      localStorage.setItem("ll_cart", JSON.stringify(next));
      return next;
    });
  }, []);

  const updateQuantity = useCallback((productId, quantity) => {
    if (quantity < 1) return;
    setItems((prev) => {
      const next = prev.map((i) =>
        i.product.id === productId ? { ...i, quantity } : i
      );
      localStorage.setItem("ll_cart", JSON.stringify(next));
      return next;
    });
  }, []);

  const clearCart = useCallback(() => {
    save([]);
  }, []);

  const totalItems = items.reduce((sum, i) => sum + i.quantity, 0);
  const getItemPrice = (item) => {
    const p = item.product;
    return p.discount > 0 ? p.price * (1 - p.discount / 100) : p.price;
  };
  const totalPrice = items.reduce((sum, i) => sum + getItemPrice(i) * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQuantity, clearCart, totalItems, totalPrice }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
